var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPillarLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 749.56 157.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #2e368f;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_13"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M229.24,60.44v18.24h-25.55v-39.9h66.76c5.33,0,7.67-3.42,7.67-7.3,0-3.65-2.56-6.84-7.67-6.84h-66.65l17-22.23h45.88c23.66,0,37.21,12.08,37.21,29.18s-13.55,28.84-37.32,28.84h-37.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M311.19,78.68V2.41h23.69v76.27h-23.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M339.64,78.68V2.41h26.33v54.38h57.91l-16.99,21.89h-67.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M424,78.68V2.41h26.33v54.38h57.91l-16.99,21.89h-67.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M542.38,78.68l15.73-21.89h16.85c3.6,0,7.87,0,10.23.23-1.12-1.25-3.6-4.79-5.17-7.18l-12.58-18.58-33.6,47.42h-30.79l48.09-67.94c3.6-5.13,8.65-9.69,16.74-9.69s12.92,4.22,16.63,9.69l46.74,67.94h-88.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M708.59,78.68l-14.48-18.92h-34.43v18.92h-26.33v-39.9h68.97c6.27,0,9.69-2.17,9.69-7.18s-3.42-6.95-9.69-6.95h-68.85l17.21-22.23h48.34c17.21,0,40.36,5.13,40.36,27.7,0,11.4-6.73,21.43-18.58,24.28,2.05,1.37,7.18,5.93,17.56,18.01l5.47,6.27h-35.23Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M338.71,122.76v-10.17h-15.13v10.17h-9.51v-27.43h9.51v9.35h15.13v-9.35h9.47v27.43h-9.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M367,122.76v-8.86l-16.6-18.57h12.18l6.19,7.5c1.11,1.31,2.54,3.12,3.07,4.1.57-1.02,1.89-2.79,2.95-4.1l5.9-7.5h11.89l-16.07,18.61v8.81h-9.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M392.58,122.76v-17.1h9.6v9.23h9.26c4.34,0,7.44-1.6,7.44-6.11,0-3.73-3.27-5.45-7.44-5.45h-18.86l6.08-8h12.78c9.84,0,16.96,5.54,16.96,13.45s-7.2,13.98-16.96,13.98h-18.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M456.67,122.76l-5.21-6.81h-12.38v6.81h-9.47v-14.35h24.81c2.25,0,3.49-.78,3.49-2.58s-1.23-2.5-3.49-2.5h-24.76l6.19-8h17.38c6.19,0,14.51,1.84,14.51,9.96,0,4.1-2.42,7.71-6.68,8.73.74.49,2.58,2.13,6.31,6.48l1.97,2.25h-12.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M486.19,123l5.48-7.87h5.87c1.25,0,2.74,0,3.56.08-.39-.45-1.25-1.72-1.8-2.58l-4.39-6.68-11.71,17.06h-10.73l16.76-24.44c1.25-1.85,3.02-3.49,5.84-3.49s4.5,1.52,5.8,3.49l16.29,24.44h-30.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M545.8,95.33h9.55v15.46c0,8.28-5.78,12.42-17.42,12.42-13.41,0-19.19-4.14-19.19-12.42v-15.46h9.47v15.46c0,3.57,1.19,4.55,9.72,4.55,5.78,0,7.87-1.27,7.87-4.55v-15.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M557.16,122.76v-27.43h8.99v19.56h19.78l-5.8,7.87h-22.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M589.16,122.76v-27.43h8.46v27.43h-8.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M616.14,122.98c-9.64,0-16.73-6.03-16.73-13.98s7.09-13.45,16.73-13.45h19.68l-6.07,8h-13.61c-4.39,0-7.22,1.39-7.22,5.45s2.83,6.11,7.22,6.11h19.68l-6.07,7.87h-13.61Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M201.14,155.81l5.36-6.91h18.18c1.08,0,1.69-.4,1.69-1.26s-.61-1.26-1.76-1.26h-13.61c-6.23,0-9.07-2.92-9.07-6.98,0-4.86,3.02-7.67,10.55-7.67h21.24l-5.36,7.02h-16.67c-1.12,0-1.69.29-1.69,1.15s.58,1.19,1.69,1.19h13.68c5.83,0,9.03,2.27,9.03,6.66,0,4.97-2.38,8.06-9.83,8.06h-23.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M268.53,156.21c-11.95,0-17.96-3.85-17.96-12.45s6.01-12.42,17.96-12.42,18,3.82,18,12.42-6.05,12.45-18,12.45ZM268.53,138.35c-7.2,0-9.65.61-9.65,5.4s2.45,5.44,9.65,5.44,9.68-.68,9.68-5.44-2.45-5.4-9.68-5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M303.89,155.81v-24.08h8.31v17.17h18.29l-5.36,6.91h-21.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M369.98,131.73h8.39v13.57c0,7.27-5.08,10.91-15.3,10.91-11.77,0-16.85-3.64-16.85-10.91v-13.57h8.31v13.57c0,3.13,1.04,4,8.53,4,5.08,0,6.91-1.12,6.91-4v-13.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M404.83,155.81v-17.06h-10.94l5.4-7.02h27.21l-5.4,7.02h-7.92v17.06h-8.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M441.16,155.81v-24.08h8.31v24.08h-8.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M485.05,156.21c-11.95,0-17.96-3.85-17.96-12.45s6.01-12.42,17.96-12.42,18,3.82,18,12.42-6.05,12.45-18,12.45ZM485.05,138.35c-7.2,0-9.65.61-9.65,5.4s2.45,5.44,9.65,5.44,9.68-.68,9.68-5.44-2.45-5.4-9.68-5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M527.78,142.89v12.92h-7.56v-19.44c0-3.6,2.12-5.08,4.54-5.08,1.01,0,1.98.25,3.31,1.4l13.64,11.99v-12.96h7.56v19.47c0,3.6-2.16,5.08-4.57,5.08-1.04,0-1.98-.29-3.31-1.44l-13.61-11.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M565.05,155.81l5.36-6.91h18.18c1.08,0,1.69-.4,1.69-1.26s-.61-1.26-1.76-1.26h-13.61c-6.23,0-9.07-2.92-9.07-6.98,0-4.86,3.02-7.67,10.55-7.67h21.24l-5.36,7.02h-16.67c-1.12,0-1.69.29-1.69,1.15s.58,1.19,1.69,1.19h13.68c5.83,0,9.03,2.27,9.03,6.66,0,4.97-2.38,8.06-9.83,8.06h-23.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M644.88,155.81v-24.08h8.31v24.08h-8.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M678.89,142.89v12.92h-7.56v-19.44c0-3.6,2.12-5.08,4.54-5.08,1.01,0,1.98.25,3.31,1.4l13.64,11.99v-12.96h7.56v19.47c0,3.6-2.16,5.08-4.57,5.08-1.04,0-1.98-.29-3.31-1.44l-13.61-11.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M732.28,155.81c-8.46,0-14.69-5.29-14.69-12.27s6.23-11.81,14.69-11.81h17.28l-5.33,7.02h-11.95c-3.85,0-6.33,1.22-6.33,4.79s2.48,5.36,6.33,5.36h17.28l-5.33,6.91h-11.95Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 644.02,
    y: 95.08,
    width: 103.81,
    height: 4.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 644.02,
    y: 105.98,
    width: 103.81,
    height: 4.99
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 644.02,
    y: 119.1,
    width: 103.81,
    height: 4.08
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 201.88,
    y: 95.33,
    width: 103.81,
    height: 4.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 201.88,
    y: 106.23,
    width: 103.81,
    height: 4.99
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 201.88,
    y: 118.68,
    width: 103.81,
    height: 4.08
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M95.29,40.58L71.86,0H0l90.69,157.35,9.83-17.06L43.19,41l52.1-.42ZM28.47,15.5h33.82l4.71,8.84h-33.43l-5.1-8.84Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "97.55 44.48 78.57 44.48 91.95 67.6 82.88 67.6 69.53 44.48 49.71 44.48 102.77 136.39 102.77 136.39 112.67 119.21 112.67 119.21 92.68 84.59 101.66 84.42 117.2 111.34 126.65 94.95 116.34 77.04 97.55 44.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "167.34 24.34 167.34 24.34 134.5 24.34 109.63 24.34 104.72 15.5 134.5 15.5 172.44 15.5 172.44 15.5 181.37 0 90.69 0 76.21 0 99.61 40.54 138.48 40.23 128.64 57.27 123.72 48.75 104.35 48.75 104.35 48.75 128.98 90.9 128.98 90.91 167.34 24.34"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPillarLogo);
export default __webpack_public_path__ + "static/media/Pillar_Logo.efa55fcf44e912502d52e47c2cffd7cf.svg";
export { ForwardRef as ReactComponent };